module.exports = __webpack_public_path__ + "static/media/34-iveco-mercedes.ee54a0d4.jpg";